<div class="application-modal">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-header">
      <div class="modal-title">온라인 시험 검사 신청</div>
      <button type="button" class="close" (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div class="section">
        <div class="section-title">신청업체 정보</div>
        <div class="guide-txt">신청업체 정보는 현재 화면에서 직접 수정 가능합니다.</div>
        <table class="table1">
          <colgroup>
            <col class="col1">
            <col class="col2">
            <col class="col3">
            <col class="col4">
            <col class="col5">
            <col class="col6">
          </colgroup>

          <tbody>
          <tr>
            <th><label for="company_name">업체명</label></th>
            <td>
              <input type="text" id="company_name" formControlName="company_name" [autofocus]="true" [ngClass]="{formErrors:formErrors['company_name']}" />
              <div *ngIf="formErrors['company_name']" class="error-message">{{formErrors['company_name']}}</div>
            </td>
            <th><label for="name_kor">대표자명</label></th>
            <td>
              <input type="text" id="name_kor" formControlName="name_kor" [ngClass]="{formErrors:formErrors['name_kor']}" />
              <div *ngIf="formErrors['name_kor']" class="error-message">{{formErrors['name_kor']}}</div>
            </td>
            <th><label for="com_number">사업자번호</label></th>
            <td>
              <input type="text" id="com_number" formControlName="com_number" [ngClass]="{formErrors:formErrors['com_number']}" />
              <div *ngIf="formErrors['com_number']" class="error-message">{{formErrors['com_number']}}</div>
            </td>
          </tr>
          <tr>
            <th><label for="zipcode">주소</label></th>
            <td colspan="3">
              <input type="text" style="width:95px" id="zipcode" formControlName="zipcode" [ngClass]="{formErrors:formErrors['zipcode']}" />
              <div *ngIf="formErrors['zipcode']" class="error-message">{{formErrors['zipcode']}}</div>

              <button class="btn1" style="width: 75px">우편번호찾기</button>

              <input type="text" style="width:374px" id="com_address" formControlName="com_address" [ngClass]="{formErrors:formErrors['com_address']}" />
              <div *ngIf="formErrors['com_address']" class="error-message">{{formErrors['com_address']}}</div>
            </td>
            <th><label for="com_tel">전화번호</label></th>
            <td>
              <input type="text" id="com_tel" formControlName="com_tel" [ngClass]="{formErrors:formErrors['com_tel']}" />
              <div *ngIf="formErrors['com_tel']" class="error-message">{{formErrors['com_tel']}}</div>
            </td>
          </tr>
          <tr>
            <th><label for="com_fax">팩스</label></th>
            <td>
              <input type="text" id="com_fax" formControlName="com_fax" [ngClass]="{formErrors:formErrors['com_fax']}" />
              <div *ngIf="formErrors['com_fax']" class="error-message">{{formErrors['com_fax']}}</div>
            </td>
            <th><label for="job">업태</label></th>
            <td>
              <input type="text" id="job" formControlName="job" [ngClass]="{formErrors:formErrors['job']}" />
              <div *ngIf="formErrors['job']" class="error-message">{{formErrors['job']}}</div>
            </td>
            <th><label for="comJob">종목</label></th>
            <td>
              <input type="text" id="job1" formControlName="job1" [ngClass]="{formErrors:formErrors['job1']}" />
              <div *ngIf="formErrors['job1']" class="error-message">{{formErrors['job1']}}</div>
            </td>
          </tr>
          <tr>
            <th><span class="red">*</span>회원사구분</th>
            <td colspan="5">
              <label class="mr30">
                <input type="radio" disabled="true" name="com_gbn" id="com_gbn" [(ngModel)]="com_gbn" [value]="1020" [checked]="com_gbn == '1020'" (change)="form.patchValue({com_gbn: '1020'})" /> 일반회원
              </label>
              <label class="mr30">
                <input type="radio" disabled="true" name="com_gbn" id="com_gbn" [(ngModel)]="com_gbn" [value]="1010" [checked]="com_gbn == '1010'" (change)="form.patchValue({com_gbn: '1010'})" /> 협의회 회원
              </label>
              <label>
                <input type="radio" disabled="true" name="com_gbn" id="com_gbn" [(ngModel)]="com_gbn" [value]="9000" [checked]="com_gbn == '9000'" (change)="form.patchValue({com_gbn: '9000'})" /> 비회원
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="section">
        <div class="section-title"><span class="red">*</span>필수정보</div>
        <table class="table2">
          <colgroup>
            <col class="col1">
            <col class="col2">
            <col class="col3">
            <col class="col4">
            <col class="col5">
            <col class="col6">
            <col class="col7">
            <col class="col8">
          </colgroup>

          <tbody>
          <tr>
            <th><label for="application_date"><span class="red">*</span>신청일자</label></th>
            <td>
              <input type="date" id="application_date" formControlName="application_date" [ngClass]="{formErrors:formErrors['application_date']}" />
              <div *ngIf="formErrors['application_date']" class="error-message">{{formErrors['application_date']}}</div>
            </td>
            <th><label for="applicant_name"><span class="red">*</span>신청자</label></th>
            <td>
              <input type="text" id="applicant_name" formControlName="applicant_name" [ngClass]="{formErrors:formErrors['applicant_name']}" />
              <div *ngIf="formErrors['applicant_name']" class="error-message">{{formErrors['applicant_name']}}</div>
            </td>
            <th><label for="applicant_hp"><span class="red">*</span>연락처</label></th>
            <td>
              <input type="text" id="applicant_hp" formControlName="applicant_hp" [ngClass]="{formErrors:formErrors['applicant_hp']}" />
              <div *ngIf="formErrors['applicant_hp']" class="error-message">{{formErrors['applicant_hp']}}</div>
            </td>
            <th><span class="red">*</span>이메일</th>
            <td>
              <input type="text" id="applicant_email" formControlName="applicant_email" [ngClass]="{formErrors:formErrors['applicant_email']}" />
              <div *ngIf="formErrors['applicant_email']" class="error-message">{{formErrors['applicant_email']}}</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <ul class="tab">
        <li class="active">안전확인시험검사 신청</li>
      </ul>

      <div class="application-modal4">
        <div class="section">
          <table class="table1">
            <colgroup>
              <col class="col1">
              <col class="col2">
              <col class="col3">
              <col class="col4">
              <col class="col5">
              <col class="col6">
            </colgroup>
            <tbody>
            <tr>
              <th><span class="red">*</span>신청종류</th>
              <td colspan="3">
                <label class="mr20"><input type="radio" name="tab4_radio" value="전항목" [checked]="form.value.tab4_radio === '전항목'" (change)="changeChecked($event)"/>전항목</label>
                <label class="mr20"><input type="radio" name="tab4_radio" value="파생모델" [checked]="form.value.tab4_radio === '파생모델'" (change)="changeChecked($event)"/>파생모델</label>
                <label class="mr20"><input type="radio" name="tab4_radio" value="동일모델" [checked]="form.value.tab4_radio === '동일모델'" (change)="changeChecked($event)"/>동일모델</label>
                <label><input type="radio" name="tab4_radio" value="보완요구 항목 재시험" [checked]="form.value.tab4_radio === '보완요구 항목 재시험'" (change)="changeChecked($event)"/>보완요구 항목 재시험</label>
              </td>
              <th>표준번호</th>
              <td><input type="text" name="tab4_apply_standard" id="tab4_apply_standard" formControlName="tab4_apply_standard" (change)="form.patchValue({tab4_apply_standard: $event.target.value})" /></td>
            </tr>
            <tr>
              <th><span class="red">*</span>품목</th>
              <td colspan="5">
                <div class="form-inline">
                  <div class="btn-group mr5">
                    <ng-container *ngFor="let item of commonList;let i = index">
                      <button
                        type="button"
                        [attr.data-index]="i"
                        class="btn btn-default btn-small"
                        [ngClass]="{active: form.value.tab4_item_gbn_code == item.common_code}"
                        (click)="onClickBtn(item, 'gbn_code');"
                        [disabled]="viewMode"
                        [innerText]="item.common_name"
                      >{{item.common_name}}</button>
                    </ng-container>
                  </div>

                  <select
                    class="form-control form-control-small mr5"
                    style="width: 250px;"
                    name="item_code"
                    formControlName="tab4_item_code"
                    [(ngModel)]="form.value.tab4_item_code"
                    [value]="form.value.tab4_item_code"
                    (change)="onChange($event);"
                    [disabled]="viewMode"
                  >
                    <option value="undefined">품목</option>
                    <option
                      *ngFor="let item of commonDetailList;let i = index"
                      [attr.data-index]="i"
                      value="{{item.common_code}}"
                    >{{item.common_name}}</option>
                  </select>

                  <select
                    class="form-control form-control-small"
                    style="width: 348px;"
                    name="item_seq"
                    formControlName="tab4_item_seq"
                    [(ngModel)]="form.value.tab4_item_seq"
                    (change)="onChangeItem($event);"
                    [disabled]="viewMode"
                  >
                    <option value="undefined">품목상세</option>
                    <option *ngFor="let item of productList" value="{{item.seq}}">{{item.label}}</option>
                  </select>
                </div>
                <div style="margin-top:8px;">
                  <input
                    type="text"
                    id="tab4_custmer_item"
                    name="tab4_custmer_item"
                    formControlName="tab4_custmer_item"
                    placeholder="요청 품목이 없는경우 품목을 기타품목으로 설정하시고 요청 품목명을 입력해 주세요."
                    (change)="form.patchValue({tab4_custmer_item: $event.target.value})"
                    [ngClass]="{formErrors:formErrors['tab4_custmer_item']}"
                    [disabled]="viewMode"
                  />
                </div>
                <div *ngIf="formErrors['tab4_item_gbn_code']" class="error-message">{{formErrors['tab4_item_gbn_code']}}</div>
              </td>
            </tr>
            <tr>
              <th>신청모델명</th>
              <td>
                <input type="text" id="tab4_model_name" name="tab4_model_name" formControlName="tab4_model_name" (change)="form.patchValue({tab4_model_name: $event.target.value})" [ngClass]="{formErrors:formErrors['tab4_model_name']}" />
                <div *ngIf="formErrors['tab4_model_name']" class="error-message">{{formErrors['tab4_model_name']}}</div>
              </td>
              <th>기준모델명</th>
              <td>
                <input type="text" id="tab4_standard_model_name" name="tab4_standard_model_name" formControlName="tab4_standard_model_name" (change)="form.patchValue({tab4_standard_model_name: $event.target.value})" [ngClass]="{formErrors:formErrors['tab4_standard_model_name']}" />
                <div *ngIf="formErrors['tab4_standard_model_name']" class="error-message">{{formErrors['tab4_standard_model_name']}}</div>
              </td>
              <th>기본모델명</th>
              <td>
                <input type="text" id="tab4_apply_model_name" name="tab4_apply_model_name" formControlName="tab4_apply_model_name" (change)="form.patchValue({tab4_apply_model_name: $event.target.value})" [ngClass]="{formErrors:formErrors['tab4_apply_model_name']}" />
                <div *ngIf="formErrors['tab4_apply_model_name']" class="error-message">{{formErrors['tab4_apply_model_name']}}</div>
              </td>
            </tr>
            <tr>
              <th>종류및등급</th>
              <td colspan="5">
                <input type="text" id="tab4_kind_grade" name="tab4_kind_grade" formControlName="tab4_kind_grade" (change)="form.patchValue({tab4_kind_grade: $event.target.value})" [ngClass]="{formErrors:formErrors['tab4_kind_grade']}" />
                <div *ngIf="formErrors['tab4_kind_grade']" class="error-message">{{formErrors['tab4_kind_grade']}}</div>
              </td>
            </tr>
            <tr>
              <th>신청사유, 변경내용</th>
              <td colspan="5">
                <input type="text" id="tab4_apply_reason" name="tab4_apply_reason" formControlName="tab4_apply_reason" (change)="form.patchValue({tab4_apply_reason: $event.target.value})" [ngClass]="{formErrors:formErrors['tab4_apply_reason']}" />
                <div *ngIf="formErrors['tab4_apply_reason']" class="error-message">{{formErrors['tab4_apply_reason']}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="section">
          <!-- <div class="div1">
            <div class="section-title"><span class="red">*</span>검사항목</div>
            <button class="btn">추가</button>
            <table class="table2">
              <colgroup>
                <col class="col1">
                <col class="col2">
                <col class="col2">
                <col class="col3">
                <col class="col4">
                <col class="col5">
              </colgroup>
              <thead>
              <tr>
                <th>번호</th>
                <th>기본모델명</th>
                <th>기준모델명</th>
                <th>종류 및 등급</th>
                <th colspan="2">신청사유, 변경내용 등</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>1</td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><button class="icon-btn del"></button></td>
              </tr>
              <tr>
                <td>2</td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><input type="text" /></td>
                <td><button class="icon-btn del"></button></td>
              </tr>
              </tbody>
            </table>
          </div> -->
          <div class="guide-area1">
            <div class="section-title">구비서류 안내</div>
            <div class="box clearfix">
              <div class="boxa">
                <div>
                  1. 사업자등록증 사본<br/>
                  2. 전기회로도<br/>
                  3. 제품 설명서(사용설명서)<br/>
                  4. 부품 명세표(부품인증서 사본)<br/>
                     . 전기적인 안전에 직접적인 영향을 주는<br/>
                       명세표<br/>
                     (제품명, 정격, 특성, 제조자 및 인증사항 등)
                </div>
                <div>
                  5. 부품사양서(모터,히터 및 변압기 등)<br/>
                  6. 절연재질의 명세서<br/>
                    (온도, 내압특성 및 난연성 등급 등)<br/>
                  7. 기본모델과 파생모델의 차이점 및 사진<br/>
                  8. 제품 표시사항(라벨)

                </div>
              </div>
              <div class="boxb">
                <div>※ 인증기관 신청 대행 시 추가 서류 (인증기관 : 한국기계전기전자시험연구원)</div>
                  1. 대리인위임장(Authorization Letter)<br/>
                  ∙ 안전인증 해외 제조자 접수 시 <br/>
                   (수입업자가 인증인 경우는 해당 없음) <br/>
                  ∙ 안전확인 해외 제조자 신고 시<br/>
                    (수입업자가 신고인 경우는 해당 없음)<br/>
              </div>
            </div>
          </div>
          <div class="div1">
            <header>
              <div class="section-title fl"><span class="red">*</span>구비서류 - 사업자 등록증, 기타 설명 문서</div>
              <div class="fr">
                <input type="file" name="tab4_file" formControlName="tab4_file" ng2FileSelect (change)="handleUploadFileChanged($event)" />
                <button class="btn1 ml5">추가</button>
              </div>
            </header>
            <table class="table3">
              <colgroup>
                <col class="col1">
                <col class="col2">
                <col class="col3">
              </colgroup>

              <thead>
              <tr>
                <th>번호</th>
                <th colspan="2">파일명</th>
              </tr>
              </thead>

              <tbody>
                <ng-container *ngIf="form.value.tab4_files.length > 0">
                  <tr *ngFor="let item of form.value.tab4_files; let i = index">
                    <td>{{(i + 1)}}</td>
                    <td class="left">
                      {{item.origin}}
                      <span class="ml5 f11">({{utilService.formatBytes(item.size)}})</span>
                    </td>
                    <td><button class="icon-btn del" (click)="deleteFile(i)"></button></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="form.value.tab4_files.length < 1">
                  <tr>
                    <td colspan="3" class="center">구비서류 - 사업자등록증, 기타 설명문서를 추가해주세요.</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="div2">
            <div class="section-title">문의·요청사항</div>
            <textarea id="tab4_request_memo" name="tab4_request_memo" formControlName="tab4_request_memo" placeholder="문의 사항 및 요청사항을 간단히 기술해 주십시요."></textarea>
          </div>
        </div>
        <div class="guide-area">
          1. 처리기간은 38일입니다. 다만, 시험·검사 항목에 따라 변동될 수 있습니다.<br/>
          2. 시료의 보관기간은 성적서 발급 일로부터 1개월입니다.<br/>
          3. 시료 보관기간이 만료된 시료는 진흥회에서 임의로 처분합니다.<br/>
          4. 시험·검사의 입회는 접수담당자에게 신청하세요, 다만, 이 경우 다른 고객의 비밀유지를 위하여 시험·검사기간이 늦어질 수 있습니다.<br/>
          5. 출장 시험·검사는 특별한 경우에 한하며 접수 담당자와 상의하십시오.<br/>
          6. 변경 신청의 경우 처음 접수번호와 함께 변경되는 사항만 작성하여 주십시오.<br/>
          7. 부적합 사항이 발생할 경우 보완 완료일 1개월 이내에 보완하실 수 있으며 이 경우, 부적합 항목 및 그로 인해 영향을 미칠 수 있는 항목에 대한 시험이 추가로 진행되며 이때 추가되는 항목에 대한 수수료를 납부하셔야 합니다.<br/>
          8. 부적합 사항이 정당한 사유 없이 보완 완료일까지 보완된 시료를 제출하지 않는 경우 안전인증(안전확인)업무가 종결 처리될 수 있습니다.
        </div>
        <div class="check">
          <div class="mb20">* 의뢰하신 검사와 관련한 모든 정보는 법률에 의해 요구 받거나, 법률에 의해 금지되지 않는한 고객과 별도의 합의가 있는 경우를 제외 하고는 비밀로 취급 됩니다.</div>
          <label [ngClass]="{formErrors:formErrors['tab4_agree']}">
            <input type="checkbox" id="tab4_agree" name="tab4_agree" formControlName="tab4_agree" (change)="form.patchValue({tab4_agree: $event.target.checked})" />
            상기 내용과 비고사항을 확인하였으며, 전기 용품 및 생활용품 안전관리법에 따라 안전확인대상 제품에 대한 안전확인시험을 받고자 신청합니다.
          </label>
          <div *ngIf="formErrors['tab4_agree']" class="error-message">{{formErrors['tab4_agree']}}</div>
        </div>
      </div>


    </div>

    <div class="modal-footer clearfix">
      <button type="button" class="btn1" (click)="activeModal.dismiss()">취소</button>
      <button type="submit" class="btn1 blue">{{btnName}}</button>
    </div>
  </form>
</div>
